import { useEffect } from 'react';

export const useUrlChange = (fn?) => {
  useEffect(() => {
    const res = nx.$event.on('url.change', fn || nx.noop);
    return () => res.destroy();
  }, []);
  return { params: nx.$root.params };
};
